import * as React from "react";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { MUIDataTableMeta } from "mui-datatables";
import * as Dati from "../../../Dati";
import { Trad } from "../../../components";
import { IsPolicyExpired, IsPolicyExpiring, GetURL } from "../../helpers/Policies";

export const GetPoliciesListColumns = (tableData: Dati.CDatiPolizzaGenerale[] | undefined) => [
    {
        name: "Polizza",
        label: `${Trad.Trad("Numero")}/${Trad.Trad("Contraente")}`,
        options: {
            filter: false,
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CDatiPolizzaGenerale(), ...tableMeta.tableData[tableMeta.rowIndex] };
                return (
                    <>
                        <b>{val}</b> <i> {(rowData?.ImportoGarantito && rowData.ImportoGarantito > 0) 
                            ? '- ' + rowData.ImportoGarantito?.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) 
                            : ''}</i>
                        <br />
                        {rowData.Contraente}
                    </>
                );
            }
        }
    },
    {
        name: "StatoPolizza",
        label: Trad.Trad("Stato"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "TipoRamo",
        label: Trad.Trad("Ramo"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "TipoProdotto",
        label: Trad.Trad("Prodotto"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "AnagPOS",
        label: Trad.Trad("POS"),
        options: {
            filter: false
        }
    },
    {
        name: "DataEmissione",
        label: Trad.Trad("DataEmissione"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "DataEffetto",
        label: Trad.Trad("DataEffetto"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "DataFine",
        label: Trad.Trad("DataFine"),
        options: {
            filter: false,
            customBodyRender: (val: string) => <span>{Trad.Trad(val)}</span>,
            setCellProps: (cellValue: string, rowIndex: number) => {
                const endDate = tableData && tableData[rowIndex].DataFine;

                return {
                    className: clsx({
                        expired: endDate && IsPolicyExpired(endDate),
                        expiring: endDate && IsPolicyExpiring(endDate)
                    })
                };
            }
        }
    },
    {
        name: "Edit",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CDatiPolizzaGenerale(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return (
                    <a href={GetURL(rowData)}>
                        <Tooltip title={Trad.Trad("Modifica")}>
                            <IconButton aria-label="edit" size="small">
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                    </a>
                );
            }
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/PoliciesList/PoliciesListColumns.tsx